export class Group {
    constructor(
        public ID: string,
        public Description: string,
        public Server: string,
        public WarnApproved: boolean,
        public MediaFTP: string,
        public PstGroup: boolean,
        public PlaybookGroup: boolean,
        public PlaybookTeam: boolean
    ) { }
}
